<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">
      {{ $t('Išrašo užsakymas') }}
    </h1>
    <div class="pt-4">
      <v-card outlined>
        <!-- form  -->
        <v-card-text>
          <v-row class="mb-0 pb-0">
            <v-col class="pb-0" cols="12" md="12">
              <el-simple-table :items="dataList" />
            </v-col>
            <v-col class="pb-0" cols="12" md="12">
              <el-autocomplete
                required
                :items="enumsClassifiers.dataVolumeOrderSav"
                enums
                itemvalue="value"
                itemtext="text"
                label="Duomenų apimtis"
                :disabled="!showData"
                tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Išrašų užsakymas. Duomenų apimtis"
                v-model="dataVolume"
              />
            </v-col>
            <!-- toggle  -->
            <v-col style="overflow: auto" cols="12" md="12">
              <v-btn-toggle
                @change="searchByChange()"
                mandatory
                v-model="searchBy"
              >
                <v-btn
                  v-if="showFizToggle"
                  active-class="active-btn-group-item"
                  small
                  value="FIZ"
                >
                  <v-icon style="padding-right: 4px">mdi-account</v-icon>
                  <span>{{ $t('Fizinis asmuo') }}</span>
                </v-btn>
                <v-btn
                  v-if="showJurToggle"
                  active-class="active-btn-group-item"
                  small
                  value="JUR"
                >
                  <v-icon style="padding-right: 4px">mdi-bank</v-icon>
                  <span>{{ $t('Juridinis asmuo') }}</span>
                </v-btn>
                 <v-btn
                  :disabled="disableFreeToggle"
                  v-if="showFreeToggle"
                  active-class="active-btn-group-item"
                  small
                  value="FREE"
                >
                  <v-icon style="padding-right: 4px">mdi-account-badge</v-icon>
                  <span>{{ $t('Apie save') }}</span>
                </v-btn>
              </v-btn-toggle>
            </v-col>

            <!-- FIZ card  -->
            <template v-if="showFiz">
              <v-col class="pb-0" cols="12" md="6">
                <el-text-field
                  required
                  label="Vardas"
                  tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Išrašų užsakymas. Vardas"
                  v-model="formData.name"
                  validateKey="FIZ_name"
                  key="FIZ_name"
                  :maxlength="100"
                />
              </v-col>
              <v-col class="pb-0" cols="12" md="6">
                <el-text-field
                  required
                  label="Pavardė"
                  tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Išrašų užsakymas. Pavardė"
                  v-model="formData.lastname"
                  validateKey="FIZ_lastname"
                  key="FIZ_lastname"
                  :maxlength="100"
                />
              </v-col>
              <v-col class="pt-0 pb-0" cols="12" md="6">
                <el-radio-group
                  class="mt-0 mb-4"
                  v-model="formData.searchType"
                  :items="searchType"
                  label="searchType"
                  required
                >
                </el-radio-group>
              </v-col>
              <v-col class="pt-0 pb-0" cols="12" md="6"></v-col>
              <template v-if="showSearchTypeCode">
                <v-col class="pb-0" cols="12" md="6">
                  <el-text-field
                    required
                    label="Asmens kodas"
                    tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Išrašų užsakymas. Asmens kodas"
                    v-model="formData.code"
                    validateKey="FIZ_code"
                    key="FIZ_code"
                    :cMask="11"
                    :length="11"
                  />
                </v-col>
                <v-col class="pb-0" cols="12" md="6"></v-col>
              </template>
              <template v-if="showSearchTypeIltuCode">
                <v-col class="pb-0" cols="12" md="6">
                  <el-text-field
                    required
                    label="ILTU kodas"
                    tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Išrašų užsakymas. ILTU kodas"
                    v-model="formData.iltu_code"
                    validateKey="FIZ_iltu_code"
                    key="FIZ_iltu_code"
                    :maxlength="20"
                  />
                </v-col>
                <v-col class="pb-0" cols="12" md="6"></v-col>
              </template>
              <template v-if="showSearchTypedateAnd">
                <v-col class="pb-0" cols="12" md="6">
                  <el-date-picker
                    required
                    label="Gimimo data"
                    pastDates
                    tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Išrašų užsakymas. Gimimo data"
                    v-model="formData.birth_date"
                    validateKey="UZS_birth_date"
                    key="UZS_birth_date"
                  />
                </v-col>
                <!-- <v-col class="pb-0" cols="12" md="6">
                  <el-autocomplete
                    required
                    :items="classifiers.country"
                    itemvalue="value"
                    itemtext="text"
                    label="Šalis"
                    tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Išrašų užsakymas. Šalis"
                    v-model="formData.country"
                    validateKey="UZS_country"
                    key="UZS_country"
                  />
                </v-col> -->
              </template>
              <v-col class="pt-0 pb-0" cols="12">
                <v-divider></v-divider>
              </v-col>
              <v-col class="pt-0 pb-0" cols="12" md="12">
                <el-radio-group
                  class="mt-0 mb-4"
                  v-model="formData.parameterType"
                  :items="parameterType"
                  label="parameterType"
                  required
                >
                </el-radio-group>
              </v-col>
              <template v-if="showParameterTypeItpsi || showParameterTypeItpsp">
                <v-col class="pb-0" cols="12" md="6">
                  <el-text-field
                    required
                    label="Identifikavimo kodas"
                    tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Išrašų užsakymas. Identifikavimo kodas"
                    v-model="formData.mandate_code"
                    :cMask="10"
                    :length="10"
                    validateKey="FIZ_id_code"
                    key="FIZ_id_code"
                  />
                </v-col>
                <v-col class="pb-0" cols="12" md="6"></v-col>
              </template>
              <template v-if="showParameterTypeNtpi">
                <v-col class="pb-0" cols="12" md="6">
                  <el-text-field
                    required
                    label="Įgaliojimo notarinio registro numeris"
                    tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Išrašų užsakymas. Įgaliojimo notarinio registro numeris"
                    v-model="formData.notarial_code"
                    :maxlength="20"
                    validateKey="FIZ_nr_code"
                    key="FIZ_nr_code"
                  />
                </v-col>
                <v-col class="pb-0" cols="12" md="6"></v-col>
              </template>
                 <v-col class="pt-0 pb-0" cols="12">
                <v-divider></v-divider>
              </v-col>
            </template>
            <!-- JUR card  -->
            <template v-if="showJur">
              <v-col class="pt-0 pb-0" cols="12" md="6">
                <el-radio-group
                  class="mt-0 mb-4"
                  label="searchType"
                  v-model="formData.searchType"
                  :items="searchTypeJUR"
                  required
                >
                </el-radio-group>
              </v-col>
              <v-col class="pt-0 pb-0" cols="12" md="6"></v-col>
              <template v-if="formData.searchType === 'jar-code'">
                <v-col class="pb-0" cols="12" md="6">
                  <el-text-field
                    required
                    label="Juridinio asmens kodas"
                    v-model="formData.code"
                    :maxlength="9"
                    validateKey="JUR_code"
                    key="JUR_code"
                  />
                </v-col>
                <v-col class="pb-0" cols="12" md="6"></v-col>
              </template>
              <template v-if="formData.searchType === 'jar-code-and-country'">
                <v-col class="pb-0" cols="12" md="6">
                  <el-text-field
                    required
                    label="Juridinio asmens kodas"
                    tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Išrašų užsakymas. Juridinio asmens kodas"
                    v-model="formData.code"
                   :maxlength="20"
                    validateKey="JUR_code"
                    key="JUR_code"
                  />
                </v-col>
                <v-col class="pb-0" cols="12" md="6">
                  <el-autocomplete
                    required
                    :items="classifiers.country"
                    itemvalue="value"
                    itemtext="text"
                    label="Valstybė"
                    tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Išrašų užsakymas. Valstybė"
                    v-model="formData.country"
                    validateKey="UZS_country"
                    key="UZS_country"
                  />
                </v-col>
              </template>
                  <v-col class="pt-0 pb-0" cols="12">
                <v-divider></v-divider>
              </v-col>
              <v-col class="pt-0 pb-0" cols="12" md="12">
                <el-radio-group
                  class="mt-0 mb-4"
                  label="parameterType"
                  v-model="formData.parameterType"
                  :items="parameterType"
                  required
                >
                </el-radio-group>
              </v-col>
              <template v-if="showParameterTypeItpsi || showParameterTypeItpsp">
                <v-col class="pb-0" cols="12" md="6">
                  <el-text-field
                    required
                    label="Identifikavimo kodas"
                    tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Išrašų užsakymas. Identifikavimo kodas"
                    v-model="formData.mandate_code"
                    :cMask="10"
                    :length="10"
                    validateKey="FIZ_id_code"
                    key="FIZ_id_code"
                  />
                </v-col>
                <v-col class="pb-0" cols="12" md="6"></v-col>
              </template>
              <template v-if="formData.parameterType === 'NTPI'">
                <v-col class="pb-0" cols="12" md="6">
                  <el-text-field
                    required
                    label="Įgaliojimo notarinio registro numeris"
                    v-model="formData.notarial_code"
                    :maxlength="20"
                    validateKey="FIZ_nr_code"
                    key="FIZ_nr_code"
                  />
                </v-col>
                <v-col class="pb-0" cols="12" md="6"></v-col>
              </template>
                  <v-col class="pt-0 pb-0" cols="12">
                <v-divider></v-divider>
              </v-col>
            </template>
            <template>
              <v-col class="pt-4 pb-0" cols="12" md="6">
                <el-autocomplete
                  required
                  :items="enumsClassifiers.docLanguage"
                  enums
                  itemvalue="value"
                  itemtext="text"
                  label="Išrašo dokumento kalba"
                  v-model="formData.docLanguage"
                />
                </v-col>
                <v-col class="pb-0" cols="12" md="6"></v-col>
                <v-col class="pb-0 pt-0" cols="12" md="12">
                  <v-divider></v-divider>
              </v-col>
            </template>
            <!-- data -->
            <template v-if="showData">
              <v-col class="pb-0" cols="12" md="6">
                <el-textarea
                  label="Duomenų naudojimo tikslas"
                  tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Išrašų užsakymas. Duomenų naudojimo tikslas"
                  v-model="formData.purpose"
                  :maxlength="2000"
                  required
                />
              </v-col>
              <v-col class="pb-0" cols="12" md="6">
                <el-textarea
                  label="Teisinis pagrindas"
                  tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Išrašų užsakymas. Teisinis pagrindas"
                  v-model="formData.legal_basic"
                  :maxlength="2000"
                  required
                />
              </v-col>
              <v-col class="pb-0" cols="12" md="6">
                <el-file-input
                  label="Duomenų naudojimo tikslo dokumentas"
                  v-model="files.purpose_file"
                  :fileData="formData.purpose_file"
                  :disabled="modeReadonly"
                  @addFile="addFile($event, 'purpose_file')"
                  @clearFile="clearFile($event, 'purpose_file')"
                ></el-file-input>
              </v-col>
              <v-col class="pb-0" cols="12" md="6">
              <el-file-input
                label="Teisinio pagrindo dokumentas"
                v-model="files.legal_basis_file"
                :fileData="formData.legal_basis_file"
                :disabled="modeReadonly"
                @addFile="addFile($event, 'legal_basis_file')"
                @clearFile="clearFile($event, 'legal_basis_file')"
              ></el-file-input>
            </v-col>
            </template>
            <v-col class="pb-0" cols="12" md="12">
              <el-autocomplete
                required
                :items="enumsClassifiers.withdrawalOrderSav"
                enums
                itemvalue="value"
                itemtext="text"
                :disabled="!showData"
                label="Atsiėmimo būdas"
                tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Išrašų užsakymas. Atsiėmimo būdas"
                v-model="formData.withdrawal"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <el-button
              class="mr-1"
              color="secondary"
              icon="atšaukti"
              title="Atšaukti"
              @click.native.stop="back()"
              :loading="loading"
            />
            <el-button
              v-if="!modeReadonly && !showFree"
              title="Apmokėti"
              :loading="loading || loadingBeforeRedirect"
              @click.native="saveData()"
              color="primary"
              icon="pirmyn"
            />
             <el-button
              v-if="!modeReadonly && showFree"
              title="Užsakyti"
              :loading="loading || loadingBeforeRedirect"
              @click.native="saveData()"
              color="primary"
              icon="pirmyn"
            />
          </v-row>
        </v-card-actions>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import userRole from '@/mixins/userRole'
import upload from '@/mixins/upload'
import moment from 'moment'
import Enums from '@/enums'
import { mapGetters } from 'vuex'

export default {
  name: 'NewOrder',
  components: {},
  mixins: [userRole, upload],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      formData: {},
      dataVolume: null,
      pageloading: false,
      loading: false,
      loadingBeforeRedirect: false,
      searchBy: null,
      classifiers: {},
      enumsClassifiers: {},
      files: {},
      uploadedFiles: {},
    }
  },
  computed: {
    ...mapGetters(['menuState', 'getStatementForFree', 'getUserType']),
    disableITPSI(){
      // dataVolumeOrderSav key
      if(this.dataVolume == "02" && this.formData.parameterType == 'ITPSI'){
         this.$set( this.formData, 'parameterType', 'NTPI')
      }
      return this.dataVolume == "02"
    },
    disableITPSP(){
      if(this.dataVolume == "03" && this.formData.parameterType == 'ITPSP'){
         this.$set( this.formData, 'parameterType', 'NTPI')
      }
      return this.dataVolume == "03"
    },
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    showSearchTypeCode() {
      return this.formData.searchType === 'ak'
    },
    showSearchTypeIltuCode() {
      return this.formData.searchType === 'iltu'
    },
    showSearchTypedateAnd() {
      return this.formData.searchType === 'birth-date-and-country'
    },
    showParameterTypeItpsp() {
      if(this.formData.parameterType === 'ITPSP'){
        this.$set(this.formData, 'notarial_code', "")
        return true
      }
      return false
    },
    showParameterTypeItpsi() {
      if(this.formData.parameterType === 'ITPSI'){
        this.$set(this.formData, 'notarial_code', "")
        return true
      }
      return false
    },
    showParameterTypeNtpi() {
      if(this.formData.parameterType === 'NTPI'){
        this.$set(this.formData, 'mandate_code', "")
        return true
      }
      return false
    },
    searchTypeJUR() {
      return [
        {
          label: this.$t('Juridinio asmens kodas'),
          value: 'jar-code',
        },
        {
          label: this.$t('Juridinio asmens kodas ir valstybė'),
          value: 'jar-code-and-country',
        },
      ]
    },
    searchType() {
      return [
        {
          label: this.$t('Asmens kodas'),
          value: 'ak',
        },
        {
          label: this.$t('ILTU kodas'),
          value: 'iltu',
        },
        {
          label: this.$t('Gimimo data'),
          value: 'birth-date-and-country',
        },
      ]
    },
    parameterType() {
      return [
        {
          label: this.$t('ITPSĮ - Informacinių technologijų priemonėmis sudarytas įgaliojimas'),
          value: 'ITPSI',
          disabled: this.disableITPSI,
          tooltip: "IR savitarna. Pradžia. Įgaliojimų registras. Išrašų užsakymas. Informacinių technologijų priemonėmis sudarytas įgaliojimas"
        },
        {
          label: this.$t('NTPĮ - Notarine tvarka patvirtintas įgaliojimas'),
          value: 'NTPI',
          tooltip: "IR savitarna. Pradžia. Įgaliojimų registras. Išrašų užsakymas. Notarine tvarka patvirtintas įgaliojimas"
        },
        {
          label: this.$t('Prokūra'),
          value: 'ITPSP',
          disabled: this.disableITPSP,
          tooltip: "Vieša paieška. Paieška. Prokūra",
        },
      ]
    },
    dataList() {
      return [
        {
          title: this.$t('Užsakymo data ir laikas'),
          value: moment().format('YYYY-MM-DD  HH:mm'),
          tooltip: "IR savitarna. Pradžia. Įgaliojimų registras. Išrašų užsakymas. Užsakymo data ir laikas"
        },
        {
          title: this.$t('Būsena'),
          value: this.$t('Rengiamas'),
          tooltip: "IR savitarna. Pradžia. Įgaliojimų registras. Išrašų užsakymas. Būsena"
        },
      ]
    },
    showFizToggle() {
      return true
    },
    showJurToggle() {
      return true
    },
    showFreeToggle() {
      return this.getUserType == 'FIZ'
    },
    disableFreeToggle(){
      return !this.getStatementForFree
    },
    showDatToggle() {
      return true
    },
    showFiz() {
      return this.searchBy === 'FIZ'
    },
    showJur() {
      return this.searchBy === 'JUR'
    },
    showFree() {
      return this.searchBy === 'FREE'
    },
    showData() {
       return this.searchBy != 'FREE'
    },
    modeReadonly() {
      return false
    },
  },
  beforeDestroy() {},
  created() {
    this.isMenuState()
    this.getClassifiers()
  },
  methods: {
    isMenuState(){
      if(this.menuState == 'show_all_without_statements'){
        this.$router.push({
          name: 'savInfoPage',
          params: {
            type: 'showOnlyStatements',
          },
        })
      }
    },
    searchByChange() {
      if(this.showFree){
        this.dataVolume = '01'
        this.$set(this.formData, 'withdrawal', "01")
      } else {
         this.formData = {}
      }
       this.$nextTick(() => {
        this.errors.clear()
        this.$nextTick(() => {
          this.$validator.reset()
        })
      })
    },
    back() {
      this.$router.push({ name: 'savOrders' })
    },
    getClassifiers() {
      if(this.menuState == 'show_all_without_statements'){
        return
      }
      this.loadDefault = true
      this.enumsClassifiers = Enums
      let requiredClassifiers = { classifiers: ['country'] }
      this.$axios
        .post(`classifiers`, requiredClassifiers)
        .then((res) => {
          this.classifiers = res.data.classifiers
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loadDefault = false
        })
    },
    addFile(file, name) {
      this.addUploadedFiles(file, name)
    },

    clearFile(event, name) {
      if (name && this.uploadedFiles.hasOwnProperty(name)) {
        delete this.uploadedFiles[name]
      }
    },
    addUploadedFiles(element, name) {
      if (element != null) {
        this.uploadedFiles[name] = element
      }
    },
    saveData() {
      if(this.getMaxUploadSize(20)){
        return this.$root.$emit('DATA_ERROR_DIRECT_TEXT', this.getMaxUploadSizeMsg(20))
      }
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.loading = true
          let formData = new FormData()

          Object.keys(this.uploadedFiles).map((key) => {
            formData.append(key, this.uploadedFiles[key])
          })

          formData.append('type', this.dataVolume || "")
          formData.append('purpose', this.formData.purpose || "")
          formData.append('legal_basis', this.formData.legal_basic || "")
          if(this.showFree){
             formData.append('person_type', "FIZ")
             formData.append('person_search_type', "FREE")
          } else {
             formData.append('person_type', this.searchBy || "")
             formData.append('person_search_type', this.formData.searchType || "")
          }
          formData.append('name', this.formData.name || "")
          formData.append('lastname', this.formData.lastname || "")
          formData.append(
            'fullname',
            this.formData.name
              ? `${this.formData.name} ${this.formData.lastname}`
              : ""
          )
          

          formData.append('language', this.formData.docLanguage)
          if(this.showSearchTypeIltuCode){
            formData.append('iltu_code', this.formData.iltu_code || '')  
          } else {
            formData.append('code', this.formData.code || '')
          }
          formData.append('birth_date', this.formData.birth_date || "")
          formData.append('country_code', this.formData.country || "")
          formData.append('mandate_type', this.formData.parameterType || "")
          formData.append('mandate_code', this.formData.mandate_code || "")
          formData.append('notarial_code', this.formData.notarial_code || '')
          formData.append('withdrawal_method', this.formData.withdrawal || "")

          let url = `statement-orders`
          this.getId && formData.append('id', this.getId)
          this.$axios
            .post(url, formData)
            .then((res) => {
              this.loadingBeforeRedirect = true
              if(this.showFree){
                this.$store.dispatch('setStatementForFree', false)
                return this.$router.push({ name: 'savOrders' })
              } else {
                if (this.isLocal) {
                  return this.$axios.post(`local/statement-orders/${res.data.statementOrder.id}/fake-payment`).then(
                      this.$router.push({name: 'savOrders'})
                    );
                } else {
                  window.location.href =  process.env.VUE_APP_BASKET_URL
                }
              }
            })
            .catch((err) => {
               err.response.data.fields = {
                purpose:  this.$t("Duomenų naudojimo tikslas"),
                legal_basis:  this.$t("Teisinis pagrindas")
              }
              this.$root.$emit('DATA_ERROR', err)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped></style>
